export default {
	init() {
    $('.pagination-buttons').on('click', '.load-more-button', function () {
      const targetPage = parseInt($(this).data('page'));
      performSearchAndPagination(targetPage);
    });
  // Function to perform AJAX request and update team members
  // Event handler for team member search and pagination
  function performSearchAndPagination(targetPage = 1, isFirstCall = false) {
    $('.team-members').addClass('loading');

    const roleFilter = $('select[name="role_filter"]').val();
    const professionalsFilter = $('select[name="art_filter"]').val();
    const searchTerm = $('input[name="search_filter"]').val();

    $.ajax({
      type: 'POST',
      url: ajax_posts.ajaxurl,
      data: {
        action: 'load_team_members',
        art_filter: professionalsFilter,
        search_filter: searchTerm,
        paged: targetPage,
      },
      success: function (response) {
        const parsedResponse = JSON.parse(response);

          // Replace existing content with new team members
          $('.team-members').html(parsedResponse.html);
          // Update pagination buttons outside the .team-members div
          $('.pagination-buttons').html(parsedResponse.pagination);

          // Remove the loading class once the AJAX request is complete
          $('.team-members').removeClass('loading');

          if (!isFirstCall) {
            $('html, body').animate({
              scrollTop: $('.team-member-filters').offset().top,
            }, 1000);
          }
        },
        error: function (errorThrown) {
          console.log(errorThrown);
        },
      });
  }
  performSearchAndPagination(1, true);

  // Event handler for Enter key in search field
  // I've limited this by waiting for the enter key as to stop spamming on keypress
  $('input[name="search_filter"]').on('keypress', function (e) {
    if (e.which === 13) {
      performSearchAndPagination(1);
    }
  });

  // Event handler for change in filter selects
  $('.filter-select').on('change', function () {
    performSearchAndPagination(1);
  });


  // Event handler for input focus
  $('input[name="search_filter"]').on('focus', function() {
    $('.clear-filter-button').show();

    $(this).addClass('focused');
  });

  // Event handler for select change
  $('.filter-select').on('change', function() {
    $('.clear-filter-button').show();
  });

  // Event handler for clear filter button click
  $('.clear-filter-button').on('click', function() {

    $('input[name="search_filter"]').val('');

    $('input[name="search_filter"]').removeClass('focused');

    let selectTags = document.querySelectorAll('.filter-select');

    for (let i = 0; i < selectTags.length; i++) {
      selectTags[i].selectedIndex = 0;
    }

    $(this).hide();
    performSearchAndPagination(1);
  });


},
finalize() {
},
};



// WEBPACK FOOTER //
// ./scripts/routes/archiveDjArtwork.js